export default "__VITE_ASSET__CVKK8ndQ__"